import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-ui-products-article-counter',
    templateUrl: './products-article-counter.html',
    styleUrl: './products-article-counter.scss',
    standalone: false
})
export class ProductsArticleCounter {
  @Input() maxNumberOfElements = 200;
  @Input() currentStateInABom = 0;
  @Input() numberOfAddedProducts: number;

  @Output() numberOfProductsChanged = new EventEmitter<number>();

  onIncreaseQuantity() {
    if (this.numberOfAddedProducts >= this.maxNumberOfElements) {
      return;
    }
    this.numberOfAddedProducts++;
    this.changeNumberOfProducts();
  }

  onDecreaseQuantity() {
    if (this.numberOfAddedProducts < 1) {
      return;
    }
    this.numberOfAddedProducts--;
    this.changeNumberOfProducts();
  }

  changeNumberOfProducts() {
    this.numberOfProductsChanged.emit(this.numberOfAddedProducts)
  }
}
